// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueX from 'vuex'
import App from './App'
import VueRouter from 'vue-router'
import routes from './config/PageRoutes'
import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueInsProgressBar from 'vue-ins-progress-bar'
import VueCustomScrollbar from 'vue-custom-scrollbar'
import VueColumnsResizable from 'vue-columns-resizable-vuetify';
import Element from 'element-ui'
import * as echarts from 'echarts';
import htmlToPdf from '@/view/disc/js/htmlToPdf.js'


import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'element-ui/lib/theme-chalk/index.css';

//引入echarts
Vue.prototype.$echarts = echarts
Vue.use(VueX)

// 设置请求头
axios.defaults.headers.post["Content-type"] = "application/json"
axios.defaults.headers.post["Access-Control-Allow-Headers"] = "*"
// 引入axios 并注入vue实例全局对象, 使用this.$axios调用
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
Vue.use(VueX)
Vue.use(VueRouter)
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
// Vue.use(VueAxios,axios)
Vue.use(Element)
// Vue.use(vue2Dropzone)
Vue.use(echarts)
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)
Vue.use(VueColumnsResizable);
Vue.component('vue-custom-scrollbar', VueCustomScrollbar)
Vue.config.productionTip = false
const router = new VueRouter({
  mode:'history',   //去除#号
  base: '/disc/', // 添加的地方 ...
  routes
})

let loginUrl=''

if (window.location.hostname != 'localhost') {
  let apiport=window.location.port;
  // let PLATFORMNAME='/'+ window.location.pathname.split("/")[1];
  // let APPNAME= PLATFORMNAME + '/'+ window.location.pathname.split("/")[2];
  // let SUBAPPNAME='/' + window.location.pathname.split("/")[3];
  // let APINAME= APPNAME + SUBAPPNAME+ 'api';
  let BASEURL=window.location.protocol+'//'+window.location.hostname+':'+ apiport;
  //let SYSAPIURL=window.location.protocol + '//'+window.location.hostname+':'+ apiport + PLATFORMNAME + "/core/sysapi"
  loginUrl=window.location.protocol + '//'+window.location.hostname+':'+ apiport + "/login"
  axios.defaults.baseURL = BASEURL
}
else {
  // let baseurl= 'http://36.133.54.240:8180/g/demo/hivueapi'
  let baseurl= 'http://127.0.0.1:8088'
  loginUrl=baseurl + '/login'
  //axios.defaults.withCredentials=true
  //axios.defaults.crossDomain=true
  axios.defaults.baseURL = baseurl
}

// 学习的这篇文章 https://juejin.cn/post/6844903785257500679
// 全局路由构造函数，判断是否登录和要跳转到页面
router.beforeEach((to, from, next) => {
  console.log("开始判断登录")
  if (to.matched.some(m => m.meta.requiresAuth)) {    // 需要登录
    let token=window.localStorage.getItem('access-token')
    if( token && window.localStorage.isLogin === '1'){
      next()
    } else {
      if (token === 'null' || token === '' || token === undefined){
        //window.location.replace(loginUrl)
        //next({path: '/login'})
        if (window.location.hostname != 'localhost')
          window.location.replace(loginUrl)
        console.log('无效 token')
        console.log(token)
        alert(token)
      }
    }
  } else {   // 不需要登录
    next()
  }
})
axios.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('access-token');
    if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          //store.commit(types.LOGOUT);
          if (window.location.hostname != 'localhost')
            window.location.replace(loginUrl)
          console.log(loginUrl)
        }
      }
      return Promise.reject(error.response.data)   // 返回接口返回的错误信息
});


/* eslint-disable no-new */

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
